// Single source of truth for beta access code validation + local persistence.
//
// Friends & Family beta code: FROG-BETA
// Validation is case-insensitive, trims whitespace, and collapses
// accidental internal whitespace before comparison.

export const VALID_BETA_CODE = "FROG-BETA";
const STORAGE_KEY = "fkn_beta_access";

/** Normalize any user input to its canonical comparison form. */
export const normalizeBetaCode = (raw: string): string =>
  (raw ?? "")
    .trim()
    .replace(/\s+/g, "") // collapse any internal whitespace (codes have no spaces)
    .toUpperCase();

/** True if the input matches the canonical beta code (case/whitespace tolerant). */
export const validateBetaCode = (code: string): boolean =>
  normalizeBetaCode(code) === VALID_BETA_CODE;

export const isBetaUser = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const grantBetaAccess = (): void => {
  try {
    localStorage.setItem(STORAGE_KEY, "true");
  } catch {
    // silent fail — sessionStorage may be blocked
  }
};

export const revokeBetaAccess = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // silent fail
  }
};
